<template>
  <wizard
    class="add-update-task-wizard aso-assembly-image"
    next-button-text="далее"
    prev-button-text="назад"
    :finish-button-text="finishBtnText"
    :hide-finish-button="disabled"
    @complete="handleWizardComplete">
    <wizard-tab :before-change="() => disableSettingsStep ? true : validateStep('step1')">
      <template #label>
        Доп. настройки
      </template>
      <settings-step
        ref="step1"
        :disabled="disableSettingsStep"
        :init-model="uploaderTaskData"
        task-type="update"
        need-show-cost
        @on-validated="onStepValidated"/>
    </wizard-tab>

    <template v-if="loading" #nextBtn>
      <p-button disabled class="disabled-save-btn" type="info">
        <el-icon class="is-loading">
          <Loading/>
        </el-icon>
      </p-button>
    </template>
  </wizard>
</template>

<script>
  import {Wizard, WizardTab} from 'src/components/UIComponents'
  import SettingsStep from "../Steps/SettingsStep"
  import {mapGetters} from "vuex"

  export default {
    name: "UpdateTaskWizardAsoAssemblyImage",
    components: {
      Wizard,
      WizardTab,
      SettingsStep,
    },
    props: {
      application: {
        type: Object,
        default: () => ({}),
      },
      finishBtnText: String,
      uploaderTaskData: {
        type: Object,
        default: () => ({}),
      },
      loading: Boolean,
      disabled: {
        type: Boolean,
        default: false,
      },
      mode: String,
    },
    emits: ['complete'],
    data() {
      return {
        showWizard: false,
        model: {},
      }
    },
    computed: {
      ...mapGetters(['selectedTask']),
      disableSettingsStep() {
        if (this.mode === 'process') return false
        return this.disabled || !['waiting_for_publisher', 'failed'].includes(this.selectedTask.status.name)
      },
    },
    methods: {
      validateStep(ref) {
        return this.$refs[ref].validate()
      },
      onStepValidated(isValid, model) {
        if (!isValid) return
        this.model = {
          ...this.model,
          ...model
        }
        localStorage.setItem('addUpdateTaskData', JSON.stringify(this.model))
      },
      handleWizardComplete() {
        this.$emit('complete', this.model)
      },
    },
  }
</script>

<style scoped>

</style>
